module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAMAAAAoLQ9TAAAAP1BMVEVHcEwejt0ejt0ejt0ejt0ejt0ejt0ejt0ejt0ejt0ejt0ejt0ejt0ejt0ejt0ejt0ejt0ejt0ejt0ejt0ejt3WcBSfAAAAFHRSTlMAKwqMgNIDI0Hr+JZtoN65FTpbQhV7GvAAAACHSURBVBjTRY9ZFsUgCEPR1locTqe7/7UWtb6XDyURSBTp8KpeJrY7yg67xHvrQmUZwkJtfEVnh7KKRIgyhFGvTf2ETgLOqgceuxxBoK2+4GqGIKTulXNPkLCR+EtkW4OZl79QLJIjnZOfqTkshO8bPliD4SAVk3xJHOMlA6p25DnrqlGtLaG8nJ4Gu4PVPoAAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/static/img/icon_power.png
// module id = azX9
// module chunks = 3